window.templates = {
    rating:{
        image: _.template('<div style="<%= width %> <%= height %>" class="icon"><div style="<%= color %> <%= webkit_mask %> <%= mask %>"></div></div>'),
        svg: _.template('<svg style="<%= width %> <%= height %> <%= color %>" class="icon" viewBox="0 0 32 32"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#aet_icon-<%= icon %>"></use></svg>')
    },
    testimonial: {},
    group: {}
};